<template>
  <div class="pe-course-site">
    <PlatDataGridSite grid-id="PeCourseSite"
                      show-label
                      :show-title="false"></PlatDataGridSite>
  </div>
</template>

<script>
import PlatDataGridSite from '../../../wrapper/grid/PlatDataGridSite'
export default {
  name: 'PeCourseSite',
  components: {
    PlatDataGridSite
  }
}
</script>

<style lang="scss">
  .pe-course-site {
    height: 100%;
  }
</style>
